import { QueryClientProvider } from "@tanstack/react-query";
import { Suspense } from "react";
import { I18nextProvider } from "react-i18next";
import { RouterProvider } from "react-router-dom";
import { Toaster } from "sonner";

import { PageLoader } from "@/components/shared";
import { RealtimeProvider, ThemeProvider } from "@/components/providers";
import i18n from "@/configs/i18n";
import { queryClient } from "@/configs/react-query";
import { router } from "@/router";
import { TooltipProvider } from "@/components/ui/tooltip";

const App = () => (
  <QueryClientProvider client={queryClient}>
    <I18nextProvider i18n={i18n}>
      <ThemeProvider>
        <TooltipProvider>
          {/* Socket router'dan TASHQARIDA: ulanish sahifa
              almashganda uzilib qayta ochilmasligi kerak — har
              almashinuvda yangi qo'l berish degani, va u har safar
              ruxsatlarni bazadan qayta o'qirdi. */}
          <RealtimeProvider>
            {/* Sahifalar `lazy` bilan yuklanadi — bu chegara ularning
                hammasini qamrab oladi. */}
            <Suspense fallback={<PageLoader />}>
              <RouterProvider router={router} />
            </Suspense>
          </RealtimeProvider>
          <Toaster richColors position="top-center" closeButton />
        </TooltipProvider>
      </ThemeProvider>
    </I18nextProvider>
  </QueryClientProvider>
);

export default App;
